// extracted by mini-css-extract-plugin
export default {"ProgressControl":"URlsi","isDragging":"wwPqo","progress":"irGgl","bufferBar":"TLx2C","elapsedBar":"FsDMs","elapsedBall":"ABx4s"};